export default __webpack_public_path__ + "locales/pt/Notifications.json?hash=1a448fec9cd6119d26ecfd2af365ff3d";